import PropTypes from 'prop-types'

export const notesPropTypes = {
  notes: PropTypes.array.isRequired,
  crudActions: PropTypes.object.isRequired,
  isScenarioPlanning: PropTypes.bool,
  filter: PropTypes.func,
}
